import jwtDecode from 'jwt-decode';

export const isJwtExpired = (token: string | null) => {
    if (token == null || token == '') return true;
    const time = new Date().getTime() / 1000;
    const decoded = jwtDecode<any>(token);
    let isExpired = false;
    if (time > decoded?.exp) isExpired = true;
    return isExpired;
};
